import React from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';

const LanguageGuard = ({ children }) => {
  const { lang } = useParams();
  const location = useLocation();
  const supportedLanguages = ["en", "ro", "es", "de"];

  // If no lang parameter, render children (for non-language routes)
  if (!lang) {
    return children;
  }

  // If lang is not supported, redirect to the same path without language
  if (!supportedLanguages.includes(lang)) {
    // Remove the language prefix from the pathname
    const pathWithoutLang = location.pathname.replace(`/${lang}`, '') || '/';
    return <Navigate to={pathWithoutLang} replace />;
  }

  // Language is valid, render children
  return children;
};

export default LanguageGuard;

// Alternative implementation that returns null for invalid languages
export const LanguageGuardStrict = ({ children }) => {
  const { lang } = useParams();
  const supportedLanguages = ["en", "ro", "es", "de"];

  // If no lang parameter, render children
  if (!lang) {
    return children;
  }

  // If lang is not supported, don't render anything
  if (!supportedLanguages.includes(lang)) {
    return null;
  }

  return children;
};

// Advanced implementation with 404 handling
export const LanguageGuardWith404 = ({ children }) => {
  const { lang } = useParams();
  const location = useLocation();
  const supportedLanguages = ["en", "ro", "es", "de"];

  // If no lang parameter, render children
  if (!lang) {
    return children;
  }
  console.log("lang is");
  console.log(lang);
   if (!supportedLanguages.includes(lang)) {
    // Option 1: Redirect to default language version
    const defaultLang = 'en';
    const pathWithDefaultLang = location.pathname.replace(`/${lang}`, `/${defaultLang}`);
    return <Navigate to={pathWithDefaultLang} replace />;
    
    // Option 2: Redirect to 404 page (uncomment below, comment above)
    // return <Navigate to="/404" replace />;
  }

  return children;
};